/**
 * MedCaddy API Client - Records Module
 * Handles medical records CRUD and download.
 */

import { apiFetch, assertOk, assertOkWithDetail } from './core';

// Records API
export const records = {
  async list(filters = {}) {
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.search) params.append('search', filters.search);

    const response = await apiFetch(`/records?${params}`);
    assertOk(response, 'Failed to fetch records');
    return response.json();
  },

  async get(id) {
    const response = await apiFetch(`/records/${id}`);
    assertOk(response, 'Failed to fetch record');
    return response.json();
  },

  async create(record) {
    const response = await apiFetch('/records', {
      method: 'POST',
      body: JSON.stringify(record)
    });
    await assertOkWithDetail(response, 'Failed to create record');
    return response.json();
  },

  async update(id, record) {
    const response = await apiFetch(`/records/${id}`, {
      method: 'PUT',
      body: JSON.stringify(record)
    });
    assertOk(response, 'Failed to update record');
    return response.json();
  },

  async delete(id) {
    const response = await apiFetch(`/records/${id}`, {
      method: 'DELETE'
    });
    assertOk(response, 'Failed to delete record');
  },

  async download(id, options = {}) {
    const intent = options.intent === 'preview' ? 'preview' : 'download';
    const response = await apiFetch(`/records/${id}/download?intent=${intent}`);
    assertOk(response, 'Failed to download record');

    const blob = await response.blob();
    const contentDisposition = response.headers.get('content-disposition');
    let fileName = `record-${id}`;

    if (contentDisposition) {
      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      if (utf8Match?.[1]) {
        try {
          fileName = decodeURIComponent(utf8Match[1]);
        } catch (_error) {
          fileName = utf8Match[1];
        }
      } else {
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
        if (fileNameMatch?.[1]) {
          fileName = fileNameMatch[1];
        }
      }
    }

    return {
      blob,
      fileName,
      fileType: response.headers.get('content-type') || blob.type || 'application/octet-stream'
    };
  }
};
